import React, { useState } from "react";
import { Modal } from "antd";
import axiosInstance from "utilities/axios";
import { notification } from "antd";

const DeleteConfirm = ({ id, open, onClose, onDelete }) => {
  const [loading, setLoading] = useState(false);
  const handleDelete = () => {
    // Actual delete logic here
    setLoading(true);
    axiosInstance
      .delete(`/equipment/inventory/${id}`)
      .then((response) => {
        notification.success({
          message: "Information",
          description: "Equipment item deleted",
        });
        onClose();
        onDelete();
      })
      .catch((error) => {
        notification.error({
          message: "Error",
          description: "Failed to delete equipment item",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal
      title="Confirm Deletion"
      open={open}
      onOk={handleDelete}
      onCancel={onClose}
      okText="Delete"
      okButtonProps={{
        danger: true,
        type: "primary",
        loading,
      }}
      cancelText="Cancel"
    >
      <p>
        <strong>Warning:</strong> This action cannot be undone. Are you sure you
        want to delete this item?
      </p>
    </Modal>
  );
};

export default DeleteConfirm;
